<template>
  <div>
    <div v-if="isComponentLoaded" class="p-5">
      <dynamic-component
        :is="dynamicComponent"
        v-bind="propsData"
        :propsData="propsData"
      ></dynamic-component>
    </div>
    <b-row>
      <b-col class="p-5">
        <h3>
          Props <a title="Copy Url" @click="copyUrl"><i class="fas fa-link me-1 text-info"></i></a>
        </h3>
        <vue-json-editor
          v-model="jsonData"
          :show-btns="true"
          :expandedOnStart="true"
          @json-save="onJsonSave"
        ></vue-json-editor>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import vueJsonEditor from 'vue-json-editor'
export default {
  components: {
    vueJsonEditor,
  },

  data() {
    return {
      isComponentLoaded: false,
      dynamicComponent: null,
      propsData: {},
      jsonData: JSON.parse(this.$route.query.props),
    }
  },
  created() {
    this.propsData = JSON.parse(this.$route.query.props)

    import(`../../components/${this.$route.params.name.replaceAll('.', '/')}.vue`).then(
      (component) => {
        this.dynamicComponent = component.default
        this.isComponentLoaded = true
      }
    )
  },
  methods: {
    onJsonSave() {
      this.isComponentLoaded = false
      this.propsData = JSON.parse(JSON.stringify(this.jsonData))
      setTimeout(() => {
        this.isComponentLoaded = true
        this.$router
          .push({
            params: this.$route.params.name,
            query: { props: JSON.stringify(this.jsonData) },
          })
          .catch(() => {})
      }, 100)
    },
    copyUrl() {
      const url = `${window.location.protocol}//${window.location.host}/components/${
        this.$route.params.name
      }?props=${JSON.stringify(this.jsonData)}`

      navigator.clipboard.writeText(url)
    },
  },
}
</script>
